import { Helmet } from "react-helmet-async";

interface SEOProps {
  title: string;
  description: string;
  path?: string;
  image?: string;
}

const SITE = "https://www.fiaba.org";
const DEFAULT_OG = `${SITE}/og-image.jpg`;

export const SEO = ({ title, description, path = "/", image }: SEOProps) => {
  const url = `${SITE}${path}`;
  const fullTitle = title.includes("FIABA") ? title : `${title} | FIABA ETS`;
  const ogImage = image ?? DEFAULT_OG;
  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      <meta property="og:type" content="website" />
      <meta property="og:locale" content="it_IT" />
      <meta property="og:site_name" content="FIABA ETS" />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={ogImage} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImage} />
    </Helmet>
  );
};
